<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 條件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="刷手號" prop="userNum">
                <a-input v-model="queryParam.userNum" placeholder="請輸入刷手號" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="舉報類型" prop="resourceType">
                <a-select v-model="queryParam.resourceType">
                  <a-select-option :value="1">
                    視頻
                  </a-select-option>
                  <a-select-option :value="2">
                    評論
                  </a-select-option>
                  <a-select-option :value="3">
                    用戶
                  </a-select-option>
<!--                  <a-select-option :value="4">
                    賽事
                  </a-select-option>-->
                  <a-select-option :value="5">
                    直播
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="舉報原因" prop="typeName">
                <a-input v-model="queryParam.typeName" placeholder="請輸入舉報原因" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="舉報理由" prop="content">
                <a-input v-model="queryParam.content" placeholder="請輸入舉報理由" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="處理狀態" prop="processStatus">
                <a-select v-model="queryParam.processStatus">
                  <a-select-option :value="1">
                    待處理
                  </a-select-option>
                  <a-select-option :value="2">
                    已處理
                  </a-select-option>
                  <a-select-option :value="3">
                    暫不處理
                  </a-select-option>
                  <a-select-option :value="4">
                    無效
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="舉報時間" prop="createTime">
                <a-range-picker format="YYYY-MM-DD" v-model="creatRanges" @change="changeCreate"></a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport">
          <a-icon type="download" />導出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <Details
        ref="Details">

      </Details>
      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.processStatus != 2">
            處理
          </a>
<!--          <a-divider type="vertical"/>
           <a @click="$refs.Details.handleUpdate(record, undefined)">
            詳情
          </a>-->
        </span>
      </a-table>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUserReport,listUserReport, delUserReport } from '@/api/platform/userReport'
import CreateForm from './modules/CreateForm'
import Details from './modules/Details'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserReport',
  components: {
    CreateForm,
    Details
  },
  mixins: [tableMixin],
  data () {
    return {
      creatRanges:[],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查詢參數
      queryParam: {
        userId: null,
        type: null,
        content: null,
        resourceId: null,
        resourceType: null,
        processStatus: null,
        processResult: null,
        userNum:null,
        createBeginTime: null,
        createEndTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '舉報人',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '舉報的用戶暱稱',
          dataIndex: 'toUserName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '刷手號',
          dataIndex: 'userNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '舉報原因',
          dataIndex: 'typeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '舉報理由',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '舉報內容',
          dataIndex: 'resourceData',
          ellipsis: true,
          align: 'center',
          width: 120
        },
        {
          title: '舉報類型',
          dataIndex: 'resourceType',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 1){
              return "視頻"
            }
            if (value == 2){
              return "評論"
            }
            if (value == 3){
              return "用戶"
            }
            if (value == 4){
              return "賽事"
            }
            if (value == 5){
              return "直播"
            }
          }
        },
        {
          title: '處理狀態',
          dataIndex: 'processStatus',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 1){
              return "待處理"
            }
            if (value == 2){
              return "已處理"
            }
            if (value == 3){
              return "暫不處理"
            }
            if (value == 4){
              return "無效"
            }
          }
        },
        {
          title: '處理項',
          dataIndex: 'auditTypeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '處理結果',
          dataIndex: 'processResult',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '舉報時間',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查詢用戶舉報業務列表 */
    getList () {
      this.loading = true
     pageUserReport(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        type: undefined,
        content: undefined,
        resourceId: undefined,
        resourceType: undefined,
        processStatus: undefined,
        processResult: undefined,
        userNum: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    changeCreate(date, dateString) {
      console.log(dateString)
      this.queryParam.createBeginTime = dateString[0]+" 00:00:00";
      this.queryParam.createEndTime = dateString[1]+" 23:59:59";
      //this.handleQuery();
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUserReport(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '刪除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/user-report/export', {
            ...that.queryParam
          }, `用戶舉報業務_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
